import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11506fa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "huddles-card promotion" }
const _hoisted_2 = { class: "promotion-header" }
const _hoisted_3 = { class: "promotion-title" }
const _hoisted_4 = { class: "promotion-body" }
const _hoisted_5 = {
  key: 1,
  class: "p-message"
}
const _hoisted_6 = {
  key: 0,
  class: "promotion-footer"
}

import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import {
    faFloppyDisk,
    faTag,
    faPencil,
} from 'fontawesome/pro-regular-svg-icons'
import Textarea from 'primevue/textarea'
import { computed, type ComputedRef, ref } from 'vue'
import { useStore } from 'vuex'
import { Permissions } from '@/mobile/src/types/auth'
import { sendPromotion } from '@/api/huddles'

interface Props {
    promotionMessage: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HuddlesPromotion',
  props: {
    promotionMessage: {}
  },
  emits: ['promotion-updated'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const draftPromotion = ref(props.promotionMessage)
const editingPromotion = ref(false)
const store = useStore()

const emit = __emit

const cancelPromotion = () => {
    draftPromotion.value = props.promotionMessage
    editingPromotion.value = false
}

const isAdmin: ComputedRef<boolean> = computed(() =>
    store.getters['permissions']?.includes(Permissions.RoleAdminBasics)
)

const updatePromotion = async () => {
    if (
        editingPromotion.value &&
        props.promotionMessage !== draftPromotion.value
    ) {
        await sendPromotion(draftPromotion.value)
        emit('promotion-updated')
    }
    editingPromotion.value = !editingPromotion.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(FontAwesomeIcon), {
          size: "lg",
          icon: _unref(faTag)
        }, null, 8, ["icon"]),
        _createTextVNode(" Promotion ")
      ]),
      (!editingPromotion.value && isAdmin.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "promotion-edit-button",
            onClick: updatePromotion
          }, [
            (!editingPromotion.value)
              ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                  key: 0,
                  size: "xs",
                  icon: _unref(faPencil)
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            _createTextVNode(" Edit ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (editingPromotion.value)
        ? (_openBlock(), _createBlock(_unref(Textarea), {
            key: 0,
            modelValue: draftPromotion.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((draftPromotion).value = $event)),
            type: "text",
            rows: "3"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (!editingPromotion.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.promotionMessage), 1))
        : _createCommentVNode("", true)
    ]),
    (editingPromotion.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "promotion-cancel-button",
            onClick: cancelPromotion
          }, " Cancel "),
          (editingPromotion.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "promotion-save-button",
                onClick: updatePromotion
              }, [
                (editingPromotion.value)
                  ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                      key: 0,
                      size: "xs",
                      icon: _unref(faFloppyDisk)
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                _createTextVNode(" Save ")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})